<template>
  <div class="fee-settings-particulars">
     
      <v-row>
        <v-col cols="12" md="8">
          <h1 class="text-left mx-4 mt-2">Fee Schedule</h1>
          <h5 class="text-left mx-4">{{ activeFeeSession.title }}</h5>
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            color="primary"
            class="mx-4 mt-2"
            :to="{ name:'AddFeeSettingsSchedule' }"
          >Add Fee Schedule</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="!isLoading && !schedules.length">
          <h2>No Fee Schedules Found</h2>
        </v-col>
        <v-col v-else cols="12" md="4" v-for="schedule in schedules" :key="schedule.id">
          <v-card
            class="mx-4 my-2"
            :to="{ name: 'EditFeeSettingsSchedule' , params: { id: schedule.id } }"
          >
            <v-card-title class="pb-0">{{ schedule.title }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="pb-0" cols="10">
                  <p class="text--secondary text-left mb-0">Instalments</p>
                </v-col>
                <v-col class="pb-0" cols="2">
                  <b class="black--text">{{ schedule.instalments }}</b>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0" cols="10">
                  <p class="text--secondary text-left mb-0">Mapped Classes</p>
                </v-col>
                <v-col class="pb-0" cols="2">
                  <b class="black--text">{{ schedule.classes }}</b>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="6" class="py-0">
                  <p class="mb-0 text-left text--secondary">Start Date</p>
                  <p class="mb-0 text-left black--text">
                    <b v-if="schedule.start_date">{{ moment(schedule.start_date).format('D MMM yyyy') }}</b>
                    <b v-else>-</b>

                  </p>
                </v-col>
                <v-col cols="6" class="py-0">
                  <p class="mb-0 text-left text--secondary">Last Payment Date</p>
                  <p class="mb-0 text-left black--text">
                    <b v-if="schedule.end_date">{{ moment(schedule.end_date).format('D MMM yyyy') }}</b>
                    <b v-else>-</b>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-snackbar v-model="snackbar.visible">
        {{ snackbar.text }}
        <template>
          <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
        </template>
      </v-snackbar>
     
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import moment from 'moment';
import TourHelper from "@utils/tour_helper";


export default {
  name: "FeeSettingsParticulars",
  data() {
    return {
      schedules: [],
      moment:moment,
      snackbar: {
          text: "",
          visible:false
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser", "isLoading", "accessToken","activeFeeSession"]),
    essentials() {
      return {
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
        accessToken: this.accessToken,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
      var steps = [];
      steps.push({id: '1', title: "Welcome to Fee Schedule Section!", description: "Create and Edit all your Fee Schedules in this page", videoLink: "https://youtube.com"});
      // steps.push({id: '2', title: "Filter Classroom", description: "Access Students from their Classroom", el: '#add-student',position:'left'});
      TourHelper.startTour(this, "fee__schedule", steps);
    },


    // gets all schedules from server
    async getAllSchedules() {
      var response;
      var url = endpoints.getAllFeeSchedules + `?session=${this.activeFeeSession.id}`;
      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response,
      });
      if (response) {
        this.schedules = response;
      }
    },
    // handles errors
    async handleApiErrors(err) {
        this.setLoading(false);
      console.log(err);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unable to process request";
        this.snackbar.visible = true;
      }
    },
  },
  created() {
    this.handleTour();
    this.getAllSchedules();
  },
};
</script>

<style scoped>
h2 {
  font-size: 24px;
}
</style>